'use client';

import { WidgetSelector } from '@/components/organisms/WidgetSelector';

const RootPage = () => (
  <div className="flex flex-col gap-400 p-400">
    <WidgetSelector />
    <div className="text-colors-content-secondary">
      Select a widget from the dropdown above to navigate to it.
    </div>
  </div>
);

export default RootPage;
